import { useEffect, useState } from "react";
import { useLocation } from "react-router";

const REFRESH_INTERVAL_MS = 5 * 60 * 1000;

// Where a review is acted on: the Approvals pages, and a Communication's review page.
const isReviewPath = (pathname: string): boolean =>
  pathname.startsWith("/review") || pathname.endsWith("/review");

/**
 * When the sidebar's pending review count should be fetched again: on coming back to the tab,
 * every few minutes while it is in view, and on the way into or out of a page where a review is
 * acted on. Not on every navigation, as nothing else changes the count.
 */
export function useReviewCountRefreshKey(): string {
  const { pathname } = useLocation();
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const refresh = (): void => {
      if (document.visibilityState === "visible") setTick((value) => value + 1);
    };

    const interval = setInterval(refresh, REFRESH_INTERVAL_MS);
    document.addEventListener("visibilitychange", refresh);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, []);

  return `${tick}:${isReviewPath(pathname) ? pathname : ""}`;
}
